import { map } from './cmsComponentMapper.map';

export function cmsComponentMapper(schema: string) {
    const schemaUrl = schema as keyof typeof map; // TODO is this kosher?
    const componentName = map[schemaUrl] ?? '';

    return componentName;
}
